/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAggregationsDetectionResult,
    InternalApiAggregationsDetectionResultFromJSON,
    InternalApiAggregationsDetectionResultToJSON,
    InternalApiScenarioContentForAggregationsDetection,
    InternalApiScenarioContentForAggregationsDetectionFromJSON,
    InternalApiScenarioContentForAggregationsDetectionToJSON,
    InternalApiScenarioContentTestResultInformation,
    InternalApiScenarioContentTestResultInformationFromJSON,
    InternalApiScenarioContentTestResultInformationToJSON,
    InternalApiScenarioTestResultsPage,
    InternalApiScenarioTestResultsPageFromJSON,
    InternalApiScenarioTestResultsPageToJSON,
    InternalApiStartScenarioVersionTest,
    InternalApiStartScenarioVersionTestFromJSON,
    InternalApiStartScenarioVersionTestToJSON,
} from '../models';

export interface CancelScenarioContentTestRunRequest {
    testHandle: string;
}

export interface DetectAggregationsRequest {
    scenarioHandle: string;
    internalApiScenarioContentForAggregationsDetection: InternalApiScenarioContentForAggregationsDetection;
}

export interface GetScenarioContentTestResultsRequest {
    scenarioHandle: string;
    contentHandle: string;
    testHandle: string;
}

export interface GetScenarioTestRunsRequest {
    page: number;
    size: number;
    scenarioHandle: string;
}

export interface StartVersionTestRequest {
    scenarioHandle: string;
    handle: string;
    internalApiStartScenarioVersionTest: InternalApiStartScenarioVersionTest;
}

/**
 * 
 */
export class ScenarioTestingApi extends runtime.BaseAPI {

    /**
     * Cancel scenario content test
     */
    async cancelScenarioContentTestRunRaw(requestParameters: CancelScenarioContentTestRunRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.testHandle === null || requestParameters.testHandle === undefined) {
            throw new runtime.RequiredError('testHandle','Required parameter requestParameters.testHandle was null or undefined when calling cancelScenarioContentTestRun.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/test-runs/{testHandle}/cancel`.replace(`{${"testHandle"}}`, encodeURIComponent(String(requestParameters.testHandle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel scenario content test
     */
    async cancelScenarioContentTestRun(requestParameters: CancelScenarioContentTestRunRequest, initOverrides?: RequestInit): Promise<void> {
        await this.cancelScenarioContentTestRunRaw(requestParameters, initOverrides);
    }

    /**
     * Detect aggregations from scenario content
     */
    async detectAggregationsRaw(requestParameters: DetectAggregationsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiAggregationsDetectionResult>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling detectAggregations.');
        }

        if (requestParameters.internalApiScenarioContentForAggregationsDetection === null || requestParameters.internalApiScenarioContentForAggregationsDetection === undefined) {
            throw new runtime.RequiredError('internalApiScenarioContentForAggregationsDetection','Required parameter requestParameters.internalApiScenarioContentForAggregationsDetection was null or undefined when calling detectAggregations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenarios/{scenarioHandle}/detect-aggregations`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScenarioContentForAggregationsDetectionToJSON(requestParameters.internalApiScenarioContentForAggregationsDetection),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiAggregationsDetectionResultFromJSON(jsonValue));
    }

    /**
     * Detect aggregations from scenario content
     */
    async detectAggregations(requestParameters: DetectAggregationsRequest, initOverrides?: RequestInit): Promise<InternalApiAggregationsDetectionResult> {
        const response = await this.detectAggregationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch scenario content test results with applied alerting interval
     */
    async getScenarioContentTestResultsRaw(requestParameters: GetScenarioContentTestResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioContentTestResultInformation>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling getScenarioContentTestResults.');
        }

        if (requestParameters.contentHandle === null || requestParameters.contentHandle === undefined) {
            throw new runtime.RequiredError('contentHandle','Required parameter requestParameters.contentHandle was null or undefined when calling getScenarioContentTestResults.');
        }

        if (requestParameters.testHandle === null || requestParameters.testHandle === undefined) {
            throw new runtime.RequiredError('testHandle','Required parameter requestParameters.testHandle was null or undefined when calling getScenarioContentTestResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v2/scenarios/{scenarioHandle}/content/{contentHandle}/tests/{testHandle}`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))).replace(`{${"contentHandle"}}`, encodeURIComponent(String(requestParameters.contentHandle))).replace(`{${"testHandle"}}`, encodeURIComponent(String(requestParameters.testHandle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioContentTestResultInformationFromJSON(jsonValue));
    }

    /**
     * Fetch scenario content test results with applied alerting interval
     */
    async getScenarioContentTestResults(requestParameters: GetScenarioContentTestResultsRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioContentTestResultInformation> {
        const response = await this.getScenarioContentTestResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get scenario test runs
     */
    async getScenarioTestRunsRaw(requestParameters: GetScenarioTestRunsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioTestResultsPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getScenarioTestRuns.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling getScenarioTestRuns.');
        }

        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling getScenarioTestRuns.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenarios/{scenarioHandle}/test-runs`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioTestResultsPageFromJSON(jsonValue));
    }

    /**
     * Get scenario test runs
     */
    async getScenarioTestRuns(requestParameters: GetScenarioTestRunsRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioTestResultsPage> {
        const response = await this.getScenarioTestRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start scenario version test
     */
    async startVersionTestRaw(requestParameters: StartVersionTestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling startVersionTest.');
        }

        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling startVersionTest.');
        }

        if (requestParameters.internalApiStartScenarioVersionTest === null || requestParameters.internalApiStartScenarioVersionTest === undefined) {
            throw new runtime.RequiredError('internalApiStartScenarioVersionTest','Required parameter requestParameters.internalApiStartScenarioVersionTest was null or undefined when calling startVersionTest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenarios/{scenarioHandle}/versions/{handle}/start-test`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))).replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiStartScenarioVersionTestToJSON(requestParameters.internalApiStartScenarioVersionTest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Start scenario version test
     */
    async startVersionTest(requestParameters: StartVersionTestRequest, initOverrides?: RequestInit): Promise<void> {
        await this.startVersionTestRaw(requestParameters, initOverrides);
    }

}
